import React, { FC, useContext } from 'react'
import { Box, Grid } from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'
import Link from '../../link/Link'
import { makeStyles } from 'tss-react/mui'
import styles from '../../../styles'
import { fontFamilyBlackerDisplay, gecinaBlueMain } from '../../../theme'
import { formatOffreModel } from '../../swiper/utils/autresElementsCrossSellingUtils'
import AutreElementCrossSellingCard from '../../swiper/AutreElementCrossSellingCard'
import { SelectionPaneContext } from './SelectionPaneContext'
import links from '../../../enums/linksEnum'
import { useNavigate } from 'react-router'
import { DEFAULT_OFFER_FILTERS } from '../../../modules/rechercheOffre/utils/rechercheOffreConstants'

const BlocOffer: FC = () => {
	const { currentOffer, hasCurrentOffer } = useContext(SelectionPaneContext)

	const intl = useIntl()
	const navigate = useNavigate()
	const { classes } = useStyles()

	return (
		<Grid container item spacing="10px">
			<Grid item className={classes.titleStyle}>
				<FormattedMessage
					id="selectionPanel.offer.title"
					defaultMessage="Recherche par offre"
					description="Recherche par offre"
				/>
			</Grid>

			{
				// Pas besoin de check sur currentOffer, car déjà dans le hasCurrentOffer
				hasCurrentOffer &&
				<Grid container item>
					<Box
						key={`${currentOffer?.sousTitre}-${currentOffer?.dateDisponibilite}`}
						width={259}
						height="fit-content"
					>
						<AutreElementCrossSellingCard
							elementCrossSelling={formatOffreModel(currentOffer!, intl, '100%', 200)}
							photoClassName={classes.photoStyle}
						/>
					</Box>
				</Grid>
			}

			<Grid container item justifyContent="flex-end">
				<Link
					// Redirection vers la page de recherche d'offre avec un filtre par défaut sur toutes les offres
					href={`${links.RECHERCHE_OFFRE}${DEFAULT_OFFER_FILTERS}`}
					onClick={() => navigate({ pathname: links.RECHERCHE_OFFRE, search: DEFAULT_OFFER_FILTERS })}
					color="colorAccessibility"
					textStyle="text4"
					prevent
				>
					<FormattedMessage
						id={`selectionPanel.${hasCurrentOffer ? 'change' : 'offer.search'}`}
						defaultMessage="Rechercher une offre"
						description="Rechercher une offre"
					/>
				</Link>
			</Grid>
		</Grid>
	)
}

const useStyles = makeStyles()((theme) => ({
	...styles(theme),
	titleStyle: {
		fontFamily: fontFamilyBlackerDisplay,
		fontSize: 18,
		fontWeight: 900,
		color: gecinaBlueMain
	},
	photoStyle: {
		marginBottom: 0
	}
}))

export default BlocOffer